import React from 'react';
import { Link } from 'react-router-dom';
import './ProfileDownloadBar.css';

/**
 * Full-width profile download / view CTA (home page).
 */
const ProfileDownloadBar = ({ to, label }) => {
  return (
    <Link to={to} className="profile-download-bar">
      <span className="profile-download-bar__icon" aria-hidden="true">
        <i className="bi bi-download" />
      </span>
      <span className="profile-download-bar__label">{label}</span>
      <i className="bi bi-chevron-right profile-download-bar__chevron" aria-hidden="true" />
    </Link>
  );
};

export default ProfileDownloadBar;
